import { CreateParams, DeleteParams, GetListParams, GetManyParams, GetManyReferenceParams, GetOneParams, UpdateParams } from 'react-admin';
import { createQuery } from '@40seas/shared/query';

export class UrlsProvider {
    constructor(private readonly apiUrl: string) {}

    getBaseUrl(resource: string) {
        return `${this.apiUrl}/${resource}`;
    }

    getOneUrl(resource: string, params: GetOneParams) {
        return `${this.apiUrl}/${resource}/${params.id}`;
    }

    getListUrl(resource: string, params: GetListParams) {
        const { pagination, sort, filter } = params;

        const query = createQuery({
            pagination,
            sort,
            filter,
            distinctBy: params.meta?.distinctBy,
            expand: params?.meta?.expand,
            aggregate: params?.meta?.aggregate,
        });

        return `${this.apiUrl}/${resource}${query ? `?${query}` : ''}`;
    }

    getManyUrl(resource: string, params: GetManyParams, target: string, queryParam?: Partial<GetListParams>) {
        const { ids } = params;
        const targetWithFilter = target.includes('__') ? target : `${target}__in`;

        const query = [
            {
                sort: queryParam?.sort,
                filter: queryParam?.filter,
                expand: queryParam?.meta?.expand,
                distinctBy: queryParam?.meta?.distinctBy,
                pagination: { page: 1, perPage: queryParam?.meta?.limit ?? 100 },
            },
            ...ids.map((id) => ({ filter: { [targetWithFilter]: `${id}` } })),
        ]
            .map((query) => createQuery(query))
            .filter(Boolean)
            .join('&');

        return `${this.apiUrl}/${resource}?${query}`;
    }

    getManyReferenceUrl(resource: string, params: GetManyReferenceParams) {
        const { filter } = params;
        const query = createQuery({ filter });
        return `${this.apiUrl}/${resource}${query ? `?${query}` : ''}`;
    }

    getCreateUrl(resource: string, params: CreateParams) {
        return `${this.apiUrl}/${resource}`;
    }

    getUpdateUrl(resource: string, params: UpdateParams) {
        return `${this.apiUrl}/${resource}${params.id ? `/${params.id}` : ''}`;
    }

    getDeleteUrl(resource: string, params: DeleteParams) {
        return `${this.apiUrl}/${resource}/${params.id}`;
    }

    getPathUrl(resource: string, path: string) {
        return `${this.apiUrl}/${resource}/${path}`;
    }
}
